import s from "./ArticleCategories.module.scss";
import { SpriteIcon } from "@/components/UI/SpriteIcon";

import searchIcon from "public/img/icons/sprite/search.svg";
import listTreeIcon from "public/img/icons/sprite/list-tree.svg";
import React from "react";
import { ArticleCategoriesModal } from "@/components/pages/blog/ai-article/components/ArticleCategoriesModal";
type ArticleCategoriesSearchModalProps = {
  articlesTotalCount: number;
  visible: boolean;
  onVisibleChange: (visible: boolean) => void;
  selectedIdCategory?: number;
  onSelectedCategoryChange?: (idCategory: number | undefined) => void;
};

export const ArticleCategoriesSearchModal = ({
  articlesTotalCount,
  visible,
  onVisibleChange,
  selectedIdCategory,
  onSelectedCategoryChange,
}: ArticleCategoriesSearchModalProps) => {
  return (
    <>
      <button type="button" onClick={() => onVisibleChange(true)} className={s.searchButton}>
        <span className={s.searchButtonInner}>
          Search{" "}
          <span className={s.end}>
            <span className={s.searchCount}>{articlesTotalCount}</span>
            <SpriteIcon icon={searchIcon} width={20} height={20} className={s.searchIcon} />
          </span>
        </span>
        <span className={s.searchButtonMob}>
          <SpriteIcon icon={listTreeIcon} width={20} height={20} />
        </span>
      </button>
      <ArticleCategoriesModal
        open={visible}
        setOpen={onVisibleChange}
        className={s.modal}
        selectedIdCategory={selectedIdCategory}
        onClose={() => {
          onSelectedCategoryChange?.(undefined);
        }}
      />
    </>
  );
};
